import React, { Component } from 'react'
import { compose, withProps } from 'recompose'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps'
import SearchBox from 'react-google-maps/lib/components/places/SearchBox'
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer'
import styled from 'styled-components'
import {
    Icon,
    IconButton,
    MenuItem,
    CircularProgress,
    Paper,
    Modal,
    Button
} from '@material-ui/core'
import axios from 'axios'
import { Marker } from 'react-google-maps'
import PlaceMarker from './PlaceMarker'
import BehinderungMenuItem from './MenuItem'
import { Shadow, Radius } from './styles'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import {
    COLOR_REGULAR,
    COLOR_KONTRAST,
    FONT_SIZE_REGULAR,
    FONT_SIZE_BIG,
    setColor,
    setFontSize
} from './modules/options'
import mapColorStyleKontrast from './mapColorStyleKontrast'
import { StyledReactMarkdown } from './styles'
import { ImpressumMarkdown, DatenschutzMarkdown } from './Descriptions'

const ContainerElement = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`

const MenuContainer = styled.div`
    ${Shadow};

    border-radius: 4rem;
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 1rem;
    top: 7rem;
    background: white;
    padding: 1rem 1rem 0 1rem;
`

class Menu extends Component {
    render() {
        return (
            <MenuContainer>
                {this.props.filters.map(b => (
                    <BehinderungMenuItem key={b.icon} {...b} />
                ))}
            </MenuContainer>
        )
    }
}

Menu = connect(
    state => ({
        filters: state.filters
    }),
    dispatch => bindActionCreators({}, dispatch)
)(Menu)

const SearchBoxInput = styled.input`
    ${Shadow};
    box-sizing: border-box;
    border: 1px solid transparent;
    width: 100%;
    max-width: 40rem;
    height: 4rem;
    margin: 1rem;
    padding: 0 4rem 0 1rem;
    border-radius: 0.2rem;
    font-size: 1.5rem;
    outline: none;
    text-overflow: ellipsis;

    @media (max-width: 830px) {
        max-width: 25rem;
    }

    @media (max-width: 360px) {
        max-width: 20rem;
    }
`

const DeleteIconButton = styled(IconButton)`
    width: 3.5rem;
    height: 3.5rem;
    position: absolute;
    right: 1.3rem;
`

const SearchBoxContainer = styled.div`
    width: 100%;
    max-width: 40rem;
    display: flex;
    position: relative;
    align-items: center;

    @media (max-width: 830px) {
        max-width: 25rem;
    }

    @media (max-width: 360px) {
        max-width: 20rem;
    }
`

class Markers extends Component {
    state = {
        places: []
    }

    filteredPlaces = () => {
        const activeFilters = this.props.filters.filter(x => x.isActive)
        let items = this.state.places
        if (activeFilters.length > 0) {
            items = this.state.places.filter(place => {
                return activeFilters.every(x => place[x.filter])
            })
        }

        return items
    }

    async componentDidMount() {
        const res = await axios.get('/api/places')
        this.setState({
            places: res.data
        })
    }

    render() {
        return (
            <MarkerClusterer averageCenter enableRetinaIcons gridSize={80}>
                {this.filteredPlaces().map(item => {
                    return <PlaceMarker key={item.id} {...item} />
                })}
            </MarkerClusterer>
        )
    }
}

Markers = connect(
    state => ({
        filters: state.filters
    }),
    dispatch => bindActionCreators({}, dispatch)
)(Markers)

class Map extends Component {
    constructor(props) {
        super(props)
        this.google = window.google
        this.state = {
            center: { lat: 52.5197809, lng: 13.3983572 },
            zoom: 10,
            bounds: null,
            markers: [],
            options: {
                fullscreenControl: false,
                mapTypeControlOptions: {
                    position: this.google.maps.ControlPosition.TOP_RIGHT
                }
            }
        }
    }

    onPlacesChanged = () => {
        const places = this.searchBox.getPlaces()
        console.log('places', places.length, places)
        if (places.length === 0) {
            return
        }

        const bounds = new this.google.maps.LatLngBounds()

        places.forEach(place => {
            console.log(
                place.geometry.location.lat(),
                place.geometry.location.lng()
            )
            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport)
            } else {
                bounds.extend(place.geometry.location)
            }
        })
        const nextMarkers = places.map(place => ({
            position: place.geometry.location
        }))

        const nextCenter =
            nextMarkers.length > 0 ? nextMarkers[0].position : this.state.center
        this.setState({
            center: nextCenter,
            markers: nextMarkers
        })
        this.map.fitBounds(bounds)
    }

    deleteSearchFilter = () => {
        this.searchBoxInput.value = ''
    }

    placeMatchesFilter = place => {
        return this.props.filters
            .filter(x => x.isActive)
            .every(x => place[x.filter])
    }

    currentColorStyle = () => {
        if (this.props.options.color === COLOR_KONTRAST) {
            return mapColorStyleKontrast
        }
        return null
    }

    options = () => {
        return {
            fullscreenControl: false,
            mapTypeControlOptions: {
                position: this.google.maps.ControlPosition.TOP_RIGHT
            },
            styles: this.currentColorStyle()
        }
    }

    initRef = map => {
        this.map = map
    }

    onIdle = () => {
        this.setState({
            bounds: this.map.getBounds(),
            center: this.map.getCenter()
        })
    }

    render() {
        return (
            <GoogleMap
                ref={this.initRef}
                defaultZoom={this.state.zoom}
                defaultMapTypeId="roadmap"
                center={this.state.center}
                options={this.options()}
                onIdle={this.onIdle}
                onTilesLoaded={this.props.onTilesLoaded}
            >
                <SearchBox
                    ref={r => (this.searchBox = r)}
                    bounds={this.state.bounds}
                    controlPosition={this.google.maps.ControlPosition.TOP_LEFT}
                    onPlacesChanged={this.onPlacesChanged}
                >
                    <SearchBoxContainer>
                        <SearchBoxInput
                            innerRef={r => (this.searchBoxInput = r)}
                            type="text"
                            placeholder="Standort suchen"
                        />
                        <DeleteIconButton onClick={this.deleteSearchFilter}>
                            <Icon>close</Icon>
                        </DeleteIconButton>
                    </SearchBoxContainer>
                </SearchBox>

                <Markers />

                {this.state.markers.map((marker, index) => (
                    <Marker key={index} position={marker.position} />
                ))}
            </GoogleMap>
        )
    }
}

Map = compose(
    withProps({
        googleMapURL:
            //'https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCi16VQ8dr841osDmqVrj7KgSigGMzUs9k',
            'https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCi16VQ8dr841osDmqVrj7KgSigGMzUs9k',
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <ContainerElement />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap,
    connect(
        state => ({
            options: state.options
        }),
        dispatch => bindActionCreators({}, dispatch)
    )
)(Map)

const OptionSelect = styled(Select)`
    ${Shadow};
    ${Radius};
    background: white;
    width: 15rem;

    @media (max-width: 768px) {
        width: 12.5rem;
    }

    > div > div {
        display: flex;
        align-items: center;
        font-size: 1.3rem;
        min-height: auto;
        height: 29px;
        padding: 0;
        padding-right: 32px;
        padding-left: 1rem;
    }
`

const OptionsFormControl = styled(FormControl)``

const Options = styled.div`
    position: absolute;
    right: 19.2rem;
    top: 1rem;

    ${OptionsFormControl} {
        margin-left: 1rem;

        &:first-child {
            margin-left: 0;
        }
    }

    @media (max-width: 900px) {
        bottom: 2.5rem;
        left: 1rem;
        top: auto;
        right: auto;
    }
`

const ProgressContainer = styled.div`
    position: absolute;
    background: #f8f8fa;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

const AppContainer = styled.div`
    position: relative;
    height: 100%;
`

const CloseIconButton = styled(IconButton)`
    width: 3.5rem;
    height: 3.5rem;
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
`

const CloseButton = styled(Button)`
    float: right;
`

const ImpressumDatenschutz = styled.div`
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
    opacity: 0.7;

    /*same as google nutzungsbedingungen*/
    line-height: 2rem;
    font-size: 1.3rem;
    background: white;
    padding: 0 0.5rem;

    @media (max-width: 768px) {
        bottom: 6rem;
        left: 1rem;
        transform: none;
    }

    a {
        color: black;
        text-decoration: none;
    }

    a:focus {
        outline: 0;
    }

    a:hover {
        font-weight: bold;
    }

    a:after {
        content: ' | ';
        color: black;
        font-weight: 400;
    }

    a:last-child:after {
        content: '';
    }
`

const ImpressumDatenschutzModal = styled(Modal)`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
`

const ImpressumDatenschutzPaper = styled(Paper)`
    position: relative;
    margin: 6rem 0;
    padding: 3rem;
    max-width: 80%;
`

class App extends Component {
    state = {
        isLoaded: false,
        modalIsOpen: false
    }

    onTilesLoaded = () => {
        this.setState({
            isLoaded: true
        })
    }

    handleClose = () => {
        this.setState({ modalIsOpen: false })
    }

    showModal = content => {
        this.setState({
            modalIsOpen: true,
            modalContent: content
        })
    }

    fontSize = () => {
        switch (this.props.fontSize) {
            case FONT_SIZE_REGULAR:
                return '100%'
            case FONT_SIZE_BIG:
                return '120%'
            default:
                return '100%'
        }
    }

    render() {
        const fontSize = this.fontSize()

        return (
            <AppContainer>
                <Map onTilesLoaded={this.onTilesLoaded} />
                <Menu />
                <Options>
                    <OptionsFormControl>
                        <OptionSelect
                            value={this.props.color}
                            onChange={e => {
                                this.props.setColor(e.target.value)
                            }}
                            inputProps={{
                                name: 'color'
                            }}
                            disableUnderline
                        >
                            <MenuItem value={COLOR_REGULAR}>
                                Standard Farben
                            </MenuItem>
                            <MenuItem value={COLOR_KONTRAST}>
                                Kontrast Farben
                            </MenuItem>
                        </OptionSelect>
                    </OptionsFormControl>
                    <OptionsFormControl>
                        <OptionSelect
                            value={this.props.fontSize}
                            onChange={e => {
                                this.props.setFontSize(e.target.value)
                            }}
                            inputProps={{
                                name: 'schrift'
                            }}
                            disableUnderline
                        >
                            <MenuItem value={FONT_SIZE_REGULAR}>
                                Normale Schrift
                            </MenuItem>
                            <MenuItem value={FONT_SIZE_BIG}>
                                Große Schrift
                            </MenuItem>
                        </OptionSelect>
                    </OptionsFormControl>
                </Options>
                {!this.state.isLoaded && (
                    <ProgressContainer>
                        <CircularProgress size={100} thickness={1} />
                    </ProgressContainer>
                )}

                <ImpressumDatenschutz>
                    <a
                        href="#"
                        onClick={() => this.showModal(ImpressumMarkdown)}
                    >
                        Impressum
                    </a>
                    <a
                        href="#"
                        onClick={() => this.showModal(DatenschutzMarkdown)}
                    >
                        Datenschutz
                    </a>

                    <ImpressumDatenschutzModal
                        disableAutoFocus
                        open={this.state.modalIsOpen}
                        onClose={this.handleClose}
                    >
                        <ImpressumDatenschutzPaper>
                            <StyledReactMarkdown
                                fontsize={fontSize}
                                source={this.state.modalContent}
                            />
                            <CloseIconButton onClick={this.handleClose}>
                                <Icon>close</Icon>
                            </CloseIconButton>
                            <CloseButton
                                variant="raised"
                                color="primary"
                                onClick={this.handleClose}
                            >
                                schließen
                            </CloseButton>
                        </ImpressumDatenschutzPaper>
                    </ImpressumDatenschutzModal>
                </ImpressumDatenschutz>
            </AppContainer>
        )
    }
}

export default connect(
    state => ({
        color: state.options.color,
        fontSize: state.options.fontSize
    }),
    dispatch =>
        bindActionCreators(
            {
                setColor,
                setFontSize
            },
            dispatch
        )
)(App)



// WEBPACK FOOTER //
// ./src/App.js